import React from "react";
import { InputField } from "../../components/form/InputField";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { showToast } from "../../utils/toast";
import { postRequest } from "../../hooks/services/services";

function ResetPassword({email, type, onClose }) {

  const schema = Yup.object().shape({
    newPassword: Yup.string()
      .required("Field is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one symbol"
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Field is required"),
  });



  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    // setLoading(true);
    try {
      const payload = {
        email,
        type,
        password: data?.newPassword,
        password_confirmation: data?.confirmPassword,
      };
      const response = await postRequest("api/v1/passwords/reset_password", payload);
      if(response.status ===  200){
        let responseData = await response.json()
        showToast(responseData?.message, "success");
        onClose();
      }
    } catch (error) {
      showToast(error.message, "error");
    }
  };

  return (
    <div>
      <section className="form_part space-cmn">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="signupTab">
              <div className="formArea border-radius-20 border-gray">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row g-4">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Create New Password <span className="text-danger">*</span>
                        </label>
                        <InputField
                          type="password"
                          name="newPassword"
                          register={register}
                          error={errors?.newPassword?.message}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Confirm New Password <span className="text-danger">*</span>
                        </label>
                        <InputField
                          type="password"
                          name="confirmPassword"
                          register={register}
                          error={errors?.confirmPassword?.message}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <button type="submit" className="black_btn">Confirm</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}

export default ResetPassword;
